// Pure: which deleted leads a given user may see in a pipeline's Deleted tab.
// No React, no Firestore. Shared by BOTH pipeline pages so the rule has exactly
// one implementation.
//
// Two filters, in order:
//   1. canSeeLead — the app-wide privacy rule. Non-negotiable.
//   2. the pipeline's own "Viewing: <agent>" filter, which only privileged
//      users have. It narrows what they already may see; it never widens it.

import { canSeeLead } from "./globalSearch";
import { isOnLead } from "./leadOwnership";

export function selectVisibleDeletedLeads({
  rows = [],
  user,
  viewAgent = "all",
  isPrivileged = false,
} = {}) {
  const narrowed = isPrivileged && viewAgent && viewAgent !== "all";
  return (rows || [])
    .filter(Boolean)
    .filter((l) => canSeeLead(l, user))
    .filter((l) => (narrowed ? isOnLead(l, viewAgent) : true))
    .sort((a, b) => (Number(b.deletedAt) || 0) - (Number(a.deletedAt) || 0));
}
